/**
 * Tシャツ特集：ヒーロー内メニュー（画像タイル）用 Splide 初期化
 * cm-brand-list.js と同じ構成。IDではなくクラスで取得し、
 * 同一ページ内に複数インスタンスがあっても対応できるようにしている。
 *
 * 配置先：assets/cm-tfh-menu-slider.js
 * ※ splide.min.css / splide.min.js は既存アセットをそのまま使うため、
 *   別途アップロード不要（tshirt-feature-hero.liquid側で asset_url 参照するだけでOK）
 */
document.querySelectorAll('.tfh__nav-splide').forEach((el) => {
  const splideInstance = new Splide(el, {
    type: 'slide',
    perMove: 1,
    speed: 500,
    gap: '20px',
    fixedWidth: '140px',
    padding: { left: 20, right: 40 },
    pagination: false,
    arrows: true,
    breakpoints: {
      1023: {
        gap: '10px',
        fixedWidth: '100px',
        padding: { left: 20, right: 32 },
        arrows: false,
      },
    },
  });

  splideInstance.mount();
});
